import { API_ENDPOINTS } from '@/constants';
import { apiClient } from '@/services/api';
import type { QuickStartResponse } from '@/types';

// The sidebar fetches this on every page, so a failure must not toast. The sidebar then
// hides its card, and Rate matrix shows the matrix without the first-time empty state.
export const fetchQuickStart = async (): Promise<QuickStartResponse> => {
  const response = await apiClient.get<QuickStartResponse>(API_ENDPOINTS.QUICK_START, {
    headers: { 'X-Skip-Error-Message': 'true' },
  });
  return response.data;
};
